/** Нормализация координат и адреса из ответа API школы. */
export function schoolGeoFromApi(s) {
    if (!s) return { lat: null, lng: null, address: '', addressFull: '' };
    const latRaw = s.lat ?? s.Lat;
    const lngRaw = s.lng ?? s.Lng;
    const lat = latRaw != null && latRaw !== '' ? Number(latRaw) : null;
    const lng = lngRaw != null && lngRaw !== '' ? Number(lngRaw) : null;
    const address = s.addressFull || s.address || '';
    return {
        lat: Number.isFinite(lat) ? lat : null,
        lng: Number.isFinite(lng) ? lng : null,
        address,
        addressFull: address,
        region: s.region || '',
        postalCode: s.postalCode || '',
        addressVerified: !!s.addressVerified
    };
}

export function profileGeoFields(geo) {
    return {
        address: geo.address,
        lat: geo.lat,
        lng: geo.lng,
        region: geo.region || '',
        postalCode: geo.postalCode || ''
    };
}
